import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { useTranslations } from "use-intl";
import { UpdateBookingInput } from "@/gql/graphql";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateBookingMutation } from "@/app/Bookings/GraphQL/bookingMutations";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useBooking } from "@/app/Bookings/Hooks/useBooking";
import { VehicleInput } from "@/app/Vehicles/Components/VehicleInput";

export function BookingChangeVehicleDialog({
  bookingId,
}: {
  bookingId: string;
}) {
  const t = useTranslations("booking.cards.changeVehicleDialog");
  const booking = useBooking(bookingId);
  const { mutateAsync } = useGqlMutation(updateBookingMutation);
  const { close } = useDialogState();

  return (
    <BaseDialog title={t("title")}>
      <GenericForm<UpdateBookingInput>
        initialValues={{
          vehicle: {
            connect: booking.vehicle.id,
          },
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: booking.id,
            input: values,
          });

          await close();
        }}
      >
        <VehicleInput
          name="vehicle.connect"
          label={t("vehicleLabel")}
          className="col-span-full"
          getQueryVariables={(search) => ({
            first: 20,
            page: 1,
            search,
            supplier_id: booking.supplier.id,
          })}
          initialFixtureValues={{
            supplier: {
              connect: booking.supplier.id,
            },
          }}
        />

        <DialogSubmitButton text={t("submit")} />
      </GenericForm>
    </BaseDialog>
  );
}
